import DireccionDto from "../models/direccionDto";

export const createAdapterDireccion = (endpoint) => {
    return new DireccionDto(endpoint)
}